"use strict";

require("babel-polyfill");

require("unfetch/polyfill");


//////////////////
// WEBPACK FOOTER
// ./node_modules/catalog/dist/cli/config/polyfills.js
// module id = 295
// module chunks = 103